<template>
    <div class="pm-smart-treatment-item">
        <pm-jaw-header showPrice :jaw="jaw" />

        <!--transition name="pm-fade-swipe-up"-->
            <div class="white" style="margin-top: 20px; padding: 0; height: Calc(100vh - 256px); padding-bottom: 10px; box-shadow: 0 8px 15px rgba(0,0,0,.03); overflow-x: hidden; overflow-y: auto;">
                <pm-treatment-option-selector :steps="steps" :jaw="jaw" :selectedRegion="selectedRegion" @updated="$emit('updated');" />
            </div>
        <!--/transition-->
    </div>
</template>

<style>
    .pm-smart-treatment-item {
        position: relative;
    }
</style>

<script>
import PmTreatmentOptionSelector from "./treatment-option-selector";
import PmJawHeader from "./jaw-header";

export default {
    components: {
        PmTreatmentOptionSelector,
        PmJawHeader,
    },
    props: {
        jaw: {
            type: String,
            default: "upper",
        },
        steps: {
            type: Object,
            default: () => {
                return ([]);
            },
        },
        index: {
            type: Number,
            default: 0,
        },
        data: {
            type: Object,
            default: () => {
                return ({});
            },
        },
        overview: {
            type: Boolean,
            default: false,
        },
        detailed: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        selectedRegion() {
            return (this.jaw === "upper") ? 0 : 5;
        },
    },
};
</script>
